module.exports = __webpack_public_path__ + "static/media/BoardRoom.c4830e22.jpg";